export const COOKIE_PRO_ID = '0193e4a4-6a88-7be7-9374-d6cca7445f40';
